// DO NOT CHANGE ORDER OF IMPORTS, tests might break
import { combineReducers } from 'redux-loop';
import newDocumentListState from '@newStore/documentList/newDocumentListState';
import newUserState from '@newStore/user/userState';
import externalDataState from '@newStore/externalData/externalDataState';
import documentApiReducer from '@newStore/documentApi/documentApiState';
import documentUIReducer from '@newStore/documentUI/documentUIState';
import referenceFramesReducer from '@newStore/referenceFrames/referenceFramesState';
import validationDataState from '@newStore/validation/validationState';
import versionsState from '@newStore/externalData/versionsState';
import sharedItemFacetsState from '@newStore/externalData/sharedItemFacets';
import { notificationReducer } from './notificationsReducer';
import { documentReducer } from './documentReducer';

import { reduxLoopUtilsReducer } from './reduxLoopUtilsReducer';

import documentSpecificReducer from '../../store/documentSpecific/documentSpecificState';

const rawStateReducer = combineReducers({
  // typescript (obviously) freaks out on the old reducers
  // @ts-ignore
  document: documentReducer,
  // @ts-ignore
  reduxLoopUtils: reduxLoopUtilsReducer,
  // @ts-ignore
  notifications: notificationReducer,
  documentApi: documentApiReducer,
  documentUI: documentUIReducer,
  referenceFrames: referenceFramesReducer,
  newDocumentList: newDocumentListState.reducer,
  newUser: newUserState.reducer,
  externalData: externalDataState.reducer,
  // @ts-expect-error no clue WHY it is not working
  validationData: validationDataState.reducer,
  versions: versionsState.reducer,
  sharedItemFacets: sharedItemFacetsState.reducer,
  documentSpecific: documentSpecificReducer,
});

export const rootReducer = (state: any, action: any) => {
  // console.group(action.type);
  console.info('ACTION', action.type, action);
  // console.time(action.type);
  const newLoop = rawStateReducer(state, action, state);
  // console.log('STATE', newLoop[0]);
  // console.log('VIEWMODEL', newLoop[0].document.viewModel);
  // console.timeEnd(action.type);
  // console.groupEnd();
  return newLoop;
};
